<ft-modal-overlay [open]="true">
    <ft-modal-chrome-ng modalClass="ft-broadcast-modal" size="full" [doneVisible]="false" [cancelVisible]="false">
        <ft-initialized-content [isInitialized]="isInitialized">
            @if (stepActive('ChooseGoal')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>

                    <div class="ft-modal-view choose-goal">
                        <h1 class="modal-heading">What's your goal for this broadcast?</h1>
                        <ft-broadcast-choose-goal-ng [story]="story" [contests]="contests"
                                                     (inviteToStory)="startLeadShare()"
                                                     (inviteToContest)="startStorytellersShare($event)" />
                    </div>
                </div>
            }
            @if (stepActive('StoryShareImageSetup')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    @if (!!contests) {
                        <a class="ft-btn ft-btn-outline-light ft-btn-back" (click)="chooseDifferentGoal()">
                            Choose a different goal
                        </a>
                    }

                    <div class="ft-modal-view image-setup">
                        <h1 class="modal-heading">Let's set up your content.</h1>
                        <p class="modal-summary">
                            Use the editor to set up content that will display with your broadcast. The final appearance may be adjusted for the channels you select in the next step.
                        </p>

                        <ft-story-image-setup-ng [story]="story" [property]="property" [options]="imageSetupOptions" />

                        <button type="button" class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm" (click)="finishImageSetup()">
                            Continue
                        </button>
                    </div>
                </div>
            }
            @if (stepActive('PhotocontestInvitationShareImageSetup')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <a class="ft-btn ft-btn-outline-light ft-btn-back" (click)="chooseDifferentGoal()">
                        Choose a different goal
                    </a>

                    <div class="ft-modal-view image-setup">
                        <h1 class="modal-heading">Let's set up your content.</h1>
                        <p class="modal-summary">
                            Use the editor below to set up content to display to your audience. The final appearance may differ
                            based on the channels you select in the next step.
                        </p>

                        <ft-story-image-setup-ng [story]="story" [property]="property" [options]="imageSetupOptions" />

                        <button type="button" class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm" (click)="finishImageSetup()">
                            Continue
                        </button>
                    </div>
                </div>
            }
            @if (stepActive('ChooseNetwork')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <a class="ft-btn ft-btn-outline-light ft-btn-back" (click)="returnToImageSetup()">
                        Return to set up your content
                    </a>
                    <div class="ft-modal-view choose-channel">
                        <h1 class="modal-heading">Which channel do you want to broadcast to?</h1>

                        <ft-broadcast-choose-network-ng [sharedTo]="storySharedTo"
                                                        (openShareModal)="openShareModal($event)" />

                        <div class="or ft-supertitle-divider">
                            <div class="ft-supertitle">OR</div>
                        </div>

                        <button class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm" (click)="finishRecommendation()">Conclude your recommendation</button>
                    </div>
                </div>
            }
            @if (stepActive('CreateImageProgress')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <div class="ft-modal-view rendering-image">
                        <div class="ft2-spinner -large"></div>
                        <h1 class="modal-heading">{{ 'flipto.account.CreatingImage' | translate }}</h1>
                    </div>
                </div>
            }
            @if (stepActive('ShareImageReady')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <a class="ft-btn ft-btn-outline-light ft-btn-back" (click)="chooseDifferentChannel()">Choose a different
                        channel</a>

                    <ft-broadcast-share-image-ready-ng [first]="story?.guest?.first"
                                                       [shareImageUrl]="shareImageUrl"
                                                       [network]="network"
                                                       [shareUrl]="shareUrl"
                                                       [shareType]="shareType"
                                                       (reprocessImage)="reprocessImage()"
                                                       (downloadShareImage)="downloadShareImage()"
                                                       (share)="openOAuth($event)"
                                                       [isRecommendationSetup]="true" />

                    <button class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm" (click)="finishRecommendation()">Conclude your recommendation</button>
                </div>
            }
            @if (stepActive('ConcludeRecommendation')) {
                <div>
                    <form #recommendationForm="ngForm" novalidate>
                        <button class="ft-btn-close" (click)="close()"></button>
                        <a class="ft-btn ft-btn-outline-light ft-btn-back" (click)="returnToImageSetup()">Return to broadcast setup</a>

                        <div class="ft-modal-view conclude-recommendation">
                            <h1 class="modal-heading">In a sentence or two, explain why you're making this recommendation.</h1>
                            <p class="modal-summary">
                                <!-- v1: ui-state="'missionControl.notifications'" — that state exists in NO
                                     registry (v1 included), so the v1 anchor rendered with no href; same here. -->
                                <a class="ft-link-underline" target="_blank">View notification list</a> (opens in new tab)
                            </p>

                            <div class="ft-broadcast-editor">
                                <div class="modal-panel-input" [class]="{'ft-field-error': recommendationForm.controls['recommendationMessage']?.invalid && recommendationSubmitted(), 'field-error': recommendationForm.controls['recommendationMessage']?.invalid && recommendationSubmitted()}">
                                    <textarea class="form-control ft-share-message"
                                              autofocus
                                              placeholder="{{ 'flipto.account.AddYourMessage' | translate }}"
                                              name="recommendationMessage"
                                              [(ngModel)]="recommendationMessage"
                                              required
                                    ></textarea>
                                </div>
                                <div class="modal-panel-input">
                                    <textarea class="form-control ft-share-message"
                                              placeholder="Instructions (optional)"
                                              disabled="disabled"
                                    >I’ve set everything up so it’s to ready to broadcast. Follow the link below to take a look at the story. When you’re ready, simply click the recommendation to review it and share with your audience. (You can always edit your broadcast to your liking.)</textarea>
                                </div>
                                <div class="ft-expiration">
                                    Keep your recommendation active for
                                    <ft-select-ng [items]="recommendationExpirationRanges"
                                                  key="date" value="name"
                                                  [(selectedKey)]="recommendationExpirationDate.date" />
                                </div>
                            </div>

                            <button class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm"
                                    type="button"
                                    (click)="createRecommendation(recommendationForm)"
                                    [disabled]="isProcessingRequest()"
                                    [style.pointer-events]="isProcessingRequest() ? 'none' : null">
                                <span class="ft-btn-label">All done!</span>
                                <span class="ft-btn-subline">Send your recommendation</span>
                                @if (isProcessingRequest()) {
                                    <span class="ft-loading-animation-dark"> <span class="ft2-spinner"></span></span>
                                }
                            </button>
                        </div>
                    </form>
                </div>
            }
        </ft-initialized-content>
    </ft-modal-chrome-ng>
</ft-modal-overlay>
